import React from "react";
import Cookies from "universal-cookie";
import { Link, Router, Route } from "react-router-dom";
import { Row } from "react-grid-system";
import { withTranslation } from "react-i18next";
import history from "../../../history";
import styles from "./Header.module.scss";
import HttpClient from "../../../lib/HttpClient";
import breifcase from "../../../images/icons/svg/breifcase.svg";
import profileIcon from "../../../images/icons/svg/profileIcon.svg";
import shareLinkIcon from "../../../images/icons/svg/share-icon.svg";
import auditViewIcon from "../../../images/icons/svg/audit-view-icon.svg";
import logOut from "../../../images/icons/svg/logOut.svg";
import security from "../../../services/Security";
import GlobalSearch from "./GlobalSearch";
import plusIcon from "../../../images/icons/svg/plus-white.svg";
import externalLinkIcon from "../../../images/icons/svg/open_icon_black.svg";
import trainingIcon from "../../../images/icons/svg/training.svg";
import ChatIcon from "../../../images/icons/svg/contact_support.svg";
import structuredContentIcon from "../../../images/icons/svg/structured-content-icon.svg";
import accountSetting from "../../../services/AccountSetting";

/* UI Kit */
import { UikButton, UikDropdown, UikDropdownItem, Uikon } from "@uik";
import "@uik/styles.css";
import "../../../font.scss";

import papercurveLogo from "../../../images/logos/papercurve-logo-colour.svg";
import CloseSVG from "../../../images/icons/svg/close.svg";

/* Variables */
const cookies = new Cookies();

class HeaderBuild extends React.Component {
  constructor() {
    super();

    const currentUserRole = security.getUserRole();
    const currentUserFirstName = security.getUserFirstName();
    const currentUserLastName = security.getUserLastName();

    this.state = {
      unreadCountIntercom: 0,
      currentUser: {
        role: currentUserRole,
        first_name: currentUserFirstName,
        last_name: currentUserLastName,
      },
    };
  }

  componentWillMount = () => {
    let _this = this;
    if (window.Intercom) {
      console.log("setting listener");
      window.Intercom("onUnreadCountChange", function (unreadCount) {
        _this.setState({ unreadCountIntercom: unreadCount });
        console.log("unreadCount", unreadCount);
      });
    }
  };

  handleLogout = (e) => {
    e.preventDefault();
    security.logout();
    history.push("/");
    HttpClient.delete("/logout.json", {}, { withCredentials: true });
  };

  handleWorkspace = (e) => {
    e.preventDefault();
    history.push("/users");
  };

  handleMyAccount = (e) => {
    e.preventDefault();
    history.push("/personalinfo");
  };

  handleStructuredContent = (e) => {
    e.preventDefault();
    history.push("/structured_content");
  };

  handleShareLinks = (e) => {
    e.preventDefault();
    history.push("/share_links");
  };

  handleAuditView = (e) => {
    e.preventDefault();
    history.push("/audit");
  };

  uploadDraft = (e) => {
    e.preventDefault();
    history.push("/drafts/upload");
  };

  render() {
    const { t } = this.props;
    const documents =
      window.location.pathname.match(/^\/document_libraries/) ||
      window.location.pathname.match(/^\/libraries\/\d+\/documents/) ||
      window.location.pathname.match(
        /^\/documents\/\d+\/*([\w]*-[\w]*)*\/?(\d)*$/
      ) ||
      this.props.latestApproved
        ? true
        : false;
    const drafts =
      window.location.pathname.match(/^\/drafts/) && !this.props.latestApproved
        ? true
        : false;
    const dashboard = window.location.pathname.match(/^\/dashboard/)
      ? true
      : false;
    const references =
      window.location.pathname.match(/^\/reference_libraries/) ||
      window.location.pathname.match(/^\/libraries\/\d+\/references/);
    const contacts = window.location.pathname.match(/^\/contacts/)
      ? true
      : false;
    const logoURL =
      this.state.currentUser.role === "admin" ||
      this.state.currentUser.role === "author"
        ? "/drafts"
        : "/document_libraries";

    const namePlateDropDown = ({ onClick }) => {
      const firstName = this.state.currentUser.first_name;
      const lastName = this.state.currentUser.last_name;
      return (
        <div className={styles.upgradeNotifierContainer}>
          <div className={styles.namePlate} onClick={onClick}>
            <div className={styles.userNamePlateAvatar}>
              <span className={styles.userNamePlateInitials}>
                {firstName.charAt(0)}
                {lastName.charAt(0)}
              </span>
            </div>
            <span id="Header_namePlate" className={styles.namePlateName}>
              {firstName}
              <Uikon className={styles.namePlateChevron}>arrow_right</Uikon>
            </span>
          </div>
        </div>
      );
    };

    const helpDropDown = ({ onClick }) => {
      return (
        <div
          className={styles.annotaionLayersDropDownContainer}
          onClick={onClick}
        >
          <div className={styles.helpTab}>help</div>
        </div>
      );
    };

    return (
      <Row
        className={styles.usersScreenHeaderContainer}
        id="usersScreenHeaderContainer"
      >
        <div className={styles.usersScreenHeader} id="usersScreenHeader">
          <div className={styles.usersScreenHeaderLogo}>
            <a href="/dashboard">
              <img className="authentication-logo" src={papercurveLogo} />
            </a>
          </div>
          <div className={styles.usersScreenHeaderMenu}>
            <a
              href="/dashboard"
              className={dashboard ? styles.selectedMenuItem : ""}
            >
              {t("header.dashboard")}
            </a>
            <a href="/drafts" className={drafts ? styles.selectedMenuItem : ""}>
              {t("header.draft")}
            </a>
            <a
              href="/document_libraries"
              className={documents ? styles.selectedMenuItem : ""}
            >
              {t("header.approved")}
            </a>
            {this.state.currentUser.role !== "viewer" && (
              <a
                href="/reference_libraries"
                className={references ? styles.selectedMenuItem : ""}
              >
                {t("header.references")}
              </a>
            )}
            {accountSetting.getSetting("papercurve_crm") === "TRUE" && (
              <a
                href="/contacts"
                className={contacts ? styles.selectedMenuItem : ""}
              >
                {t("header.contacts")}
              </a>
            )}
            <UikDropdown DisplayComponent={helpDropDown} position="bottomRight">
              <UikDropdownItem>
                <a
                  className={styles.kbLink}
                  href="https://help.papercurve.com/"
                  target="_blank"
                >
                  <img className={styles.externalLink} src={externalLinkIcon} />
                  Knowledge Base
                </a>
              </UikDropdownItem>
              {/* <UikDropdownItem>
                <img className={styles.trainingIconStyle} src={trainingIcon} />
                Free Training
              </UikDropdownItem> */}
              <UikDropdownItem id="chat_button">
                <img className={styles.chatIconStyle} src={ChatIcon} />
                Live Chat
              </UikDropdownItem>
            </UikDropdown>
          </div>
          <div className={styles.globalSearch}>
            <GlobalSearch />
          </div>
          {this.state.currentUser.role !== "viewer" && (
            <UikButton
              className={styles.uploadAction}
              onClick={(e) => this.uploadDraft(e)}
            >
              <img className={styles.plusIcon} src={plusIcon} />
              {t("common_terms.new")}
            </UikButton>
          )}
          <div className={styles.divider}></div>
          <div className={styles.headerNamePlate}>
            <div>
              <UikDropdown
                DisplayComponent={namePlateDropDown}
                position="bottomRight"
              >
                {this.state.currentUser.role !== "viewer" && (
                  <UikDropdownItem
                    className={styles.firstDropdownItem}
                    onClick={(e) => this.handleWorkspace(e)}
                  >
                    <img className={styles.dropdownIcon} src={breifcase} />
                    {t("header.workspace")}
                  </UikDropdownItem>
                )}
                <UikDropdownItem onClick={(e) => this.handleMyAccount(e)}>
                  <img className={styles.dropdownIcon} src={profileIcon} />
                  {t("header.my_account")}
                </UikDropdownItem>
                {this.state.currentUser.role !== "viewer" && (
                  <UikDropdownItem
                    onClick={(e) => this.handleStructuredContent(e)}
                  >
                    <img
                      className={styles.dropdownIcon}
                      src={structuredContentIcon}
                    />
                    {t("header.structured_content")}
                  </UikDropdownItem>
                )}
                <UikDropdownItem
                  id="Header_shareLink"
                  onClick={(e) => this.handleShareLinks(e)}
                >
                  <img className={styles.dropdownIcon} src={shareLinkIcon} />
                  {t("header.share_links")}
                </UikDropdownItem>
                {this.state.currentUser.role == "admin" && (
                  <UikDropdownItem
                    id="Header_auditView"
                    onClick={(e) => this.handleAuditView(e)}
                  >
                    <img className={styles.dropdownIcon} src={auditViewIcon} />
                    {t("header.audit_view")}
                  </UikDropdownItem>
                )}
                <UikDropdownItem
                  id="Header_signOut"
                  onClick={(e) => this.handleLogout(e)}
                >
                  <img className={styles.dropdownIcon} src={logOut} />
                  {t("header.sign_out")}
                </UikDropdownItem>
              </UikDropdown>
            </div>
          </div>
        </div>
      </Row>
    );
  }
}

const Header = withTranslation()(HeaderBuild);

export default Header;
